import * as React from "react";
export const accountTypesTick = (React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M0 4.19412L1.0663 3.10595L3.83322 5.83459L9.68968 0L10.7724 1.08817L3.83322 8L0 4.19412Z", fill: "#0E1D31" })));
